<template>
 <div>
   <banner :title="error" :active.sync="showBanner"  :error="!!error" />
   <jobseeker-signup title="Signup"
                     :subtitle="this.$t('signup.subtitleHirer')"
                     :progdetail="progdetail"
                     number="01"
                     description="Your company name, etc."
                     detail="Just the basics to start with"
                     formtype="Hirer"
                     v-on:continue="continuePressed"
                     :loading="loading"
                     :disabled="!checkFormData"
                     :tasks="tasks">

     <image-edit :imageUrl="profilePictureUrl" title="Change avatar"
                 v-on:change="uploadImage" :loading="uploading"
                 :isRow="true" />
     <hirer-form :showOptional="true" :bioError="bioError" />
   </jobseeker-signup>
 </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import HirerForm from '@/components/signup/hirer-form'
import ImageEdit from '@/components/profile/image-edit'
import JobseekerSignup from '@/templates/jobseeker-signup'
import Actions from '@/api/actions'
import Banner from '../components/general/banner'

export default {
  components: {
    HirerForm,
    JobseekerSignup,
    ImageEdit,
    Banner
  },
  computed: {
    ...mapState('hirerProfileForm', ['bioError']),
    ...mapState('signupForm', {
      formProfile: 'profile'
    }),
    ...mapGetters('users', [
      'profilePictureUrl',
      'user'
    ]),
    ...mapGetters('hirerProfileForm', [
      'formData'
    ]),
    ...mapState('companyForm', [
      'currentCompany'
    ]),
    checkFormData () {
      const formData = this.formData
      if (formData.profile) {
        return formData.profile.length !== 0
      }
    },
    progdetail () {
      let detail = 'Complete your profile to show who you are and to get started making great hires'
      return detail
    }
  },
  async mounted () {
    await this.getUser()
    const user = this.user
    this.loadWithUser({user, profile: 'hirer'})
  },
  methods: {
    ...mapActions('users', [
      'getUser',
      'uploadProfileImage',
      'updateUser'
    ]),
    ...mapActions('hirerProfileForm', [
      'loadWithUser'
    ]),
    ...mapMutations('hirerProfileForm', [
      'setBioError'
    ]),
    ...mapActions('companyForm', [
      'setData',
      'createNewCompany'
    ]),
    ...mapActions('hirerForm', ['attachHirer']),

    selectAvatar () {
      const ele = this.$refs.profileImageUpload
      ele.click()
    },
    async uploadImage (file) {
      this.uploading = true
      await this.uploadProfileImage(file)
      this.mFile = file
      window.setTimeout(() => {
        this.uploading = false
      }, 1000)
    },
    async continuePressed () {
      try {
        const data = this.formData
        if (data.bio.length === 0) {
          this.setBioError('Bio is required')
          return false
        } else if (data.bio.length < 50) {
          this.setBioError('Minimum 50 characters required')
          return false
        }
        this.loading = true
        await this.updateUser({profile: 'hirer', bio: data.bio, locationPlaceId: data.locationPlaceId, locationTitle: data.locationTitle})
        this.setData({image: this.mFile, name: data.companyName, domain: data.companyDomain, category: data.category, companyJobsBoard: data.companyJobsBoard, bio: data.bio})

        await this.createNewCompany()
        const companyId = this.currentCompany.id
        await this.attachHirer(companyId)

        this.loading = false
        this.$ga.event('Onboarding', 'Complete', 'Hirer', 1)

        const { route } = await Actions.signup()
        this.$router.push(route)
      } catch (err) {
        this.showBanner = true
        this.error = err.message
        this.loading = false
      }
    }
  },
  data () {
    return {
      checked: true,
      tasks: [{
        name: 'Profile',
        completed: false
      }],
      uploading: false,
      loading: false,
      mFile: null,
      error: null,
      showBanner: false
    }
  }
}
</script>

<style lang="scss" scoped>

.image-select {
  display: flex;
  margin-bottom: 24px;
}

.field {
  width: 100%;
}

.image-select a {
  margin-left: 12px;
}

.margin-title {
  margin-bottom: 40px;
}

.tracker {
  margin-top: -16px;
}

</style>



// WEBPACK FOOTER //
// src/pages/hirer-signup.vue